import { createAsyncThunk } from '@reduxjs/toolkit';
import { createFeedback } from '../../api/create-feedback';

type CreateFeedbackThunkRequest = {
    email: string
    name: string
    phone: string
    text: string
}

export const createFeedbackThunk = createAsyncThunk(
    'createFeedbackThunk',
    async ({
        email,
        name,
        phone,
        text,
    }: CreateFeedbackThunkRequest) => createFeedback(email, name, phone, text),
);
